import { BaseGroup } from '@lib/core/model';

import { Battery, DeviceListItem } from '../model';

import { DeviceNetworkMapper } from './device-network.mapper';
import { ProfileMapper } from './profile.mapper';
import { SimInfoMapper } from './sim-info.mapper';

export class DeviceListItemMapper {
  public static map(data: any): DeviceListItem {
    return data
      ? new DeviceListItem(
        data.id,
        data.uuid,
        data.active,
        data.activation,
        data.lastContact,
        data.locked,
        data.vendor,
        data.model,
        data.imei,
        data.serialNumber,
        data.operatingSystem,
        data.simInfo ? data.simInfo.map(SimInfoMapper.map) : [],
        data.dep,
        data.profiles instanceof Array ? data.profiles.map(ProfileMapper.map) : [],
        data.securityStatus,
        data.isActivationLockSupported,
        data.ownership,
        data.language,
        data.alias,
        data.mdmClientVersion,
        DeviceNetworkMapper.map(data.network),
        data.securityPatch,
        data.buildNumber,
        data.bootloaderVersion,
        data.roamingAllowed,
        data.battery ? new Battery(data.battery.level, data.battery.health) : null,
        data.availableStorage,
        data.totalStorage,
        data.firmware,
        typeof data.progetId === 'string' ? data.progetId.replace(/.{3}$/, ' $&') : data.progetId,
        data.activatedAt,
        data.androidEnterpriseStatus,
        data.googleServices,
        data.updateStatus,
        data.lastLocationAddress,
        Array.isArray(data.groups) ? data.groups.map((group) => new BaseGroup(group.id, group.name)) : [],
        data.declarativeManagement,
        data.wifiMacAddress
      )
      : null;
  }
}
